//import { message } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IEntityManagerProps, IEntityManagerStates, IMetadata } from "../../components/entityManager/interfaces";
import { ICallOptions, IEntity, IFetchingResult, IOrdering, IPaging } from "../../components/infrastructure/models";

interface IEvaluator extends IEntity {
    Name?: string;
    Code?: string;
    Phone?: string;
    ProvinceName?: string;
    ProvinceCode?: string;
    CityName?: string;
    CityCode?: string;
    Address?: string;
    WorkTime?: string;
}
export interface IEvaluatorProps extends IEntityManagerProps<IEvaluator> {
    provinceCode?: string;
    cityCode?: string;
}
export interface IEvaluatorStates extends IEntityManagerStates<IEvaluator> {

}

export interface IEvaluatorFetchingResultDto extends IFetchingResult<IEvaluator> {
    EvaluatorsCount: number;
}

export class Evaluator extends EntityManager<IEvaluator, IEvaluatorProps, IEvaluatorStates> {
    static initMetadata = (): IMetadata => {
        return {
            name: "Evaluator",
            title: "ارزیاب",
            Properties: [
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    width: 70,
                },
                {
                    title: "نام مرکز",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    width: 150,
                },
                {
                    title: "استان",
                    dataIndex: "ProvinceName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    width: 150,
                },
                {
                    title: "شهر",
                    dataIndex: "CityName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    width: 150,
                },
                {
                    title: "آدرس",
                    dataIndex: "Address",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    width: 800,
                },
                {
                    title: "تلفن",
                    dataIndex: "Phone",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    renderColumn: (_, record: IEvaluator) => <>{(!!record.Phone && !record.Phone.startsWith('0') ? '0' : '') + record.Phone ?? ''}</>,
                    width: 150,
                },
                {
                    title: "ساعت کار مرکز",
                    dataIndex: "WorkTime",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    width: 150,
                }
            ]
        };
    }
    searchValue?: any;
    onInitializing() {
        super.onInitializing();
        this.getInitialDataUrl = "center/getinitialdata";
    }
    async search(value?: any, _?: string, paging?: IPaging, ordering?: IOrdering) {
        this.searchValue = value;

        if (ordering)
            this.ordering = ordering;

        if (paging)
            this.paging = paging;

        await this.fetchData();
    }
    async fetchData() {

        let fetchOpt: ICallOptions = {
            url: 'portal/evaluators',
            data: { provinceCode: this.props.provinceCode, cityCode: this.props.cityCode, search: this.searchValue, paging: this.paging, ordering: this.ordering },
            onSuccess: (result) => {

                if (!this.mounted && !result.ValidationState.Successful)
                    return;

                //let res: any = result;

                //if (this.props.isLookupMode && this.props.cityCode && !(res.Data as IEvaluator[]).filter(e => e.CityCode === this.props.cityCode).length && !this.searchValue)
                //    message.warn("در آدرس انتخابی شما ارزیاب فعال وجود ندارد، در صورت تمایل از لیست مراکز ارزیابی، مرکز مورد نظر خود را انتخاب بفرمایید.", 5);

                if (this.props.onDataFetched) {
                    this.props.onDataFetched(result as IFetchingResult<IEvaluator>);
                    return;
                }
            },
            onError: () => {
                if (this.props.onDataFetched)
                    this.props.onDataFetched({ Data: [], TotalResultCount: 0, ValidationState: { Successful: false, ValidationResults: [] } });
            }
        };
        await this.callApi(fetchOpt);
    }
}